export const ClipboardIcon = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.875 0.235352C8.52151 0.235352 9.13753 0.499778 9.58887 0.963867C9.88187 1.26532 10.0884 1.63535 10.1982 2.03516H11.375C12.0215 2.03516 12.6375 2.29958 13.0889 2.76367C13.5395 3.22724 13.79 3.85232 13.79 4.5V15.2998C13.79 15.9475 13.5395 16.5726 13.0889 17.0361C12.6375 17.5003 12.0216 17.7656 11.375 17.7656H2.625C1.97842 17.7656 1.36249 17.5003 0.911133 17.0361C0.46046 16.5726 0.210024 15.9475 0.209961 15.2998V4.5C0.210011 3.85232 0.46051 3.22724 0.911133 2.76367C1.36247 2.29958 1.97849 2.03516 2.625 2.03516H3.80176C3.91164 1.63535 4.11813 1.26532 4.41113 0.963867C4.86247 0.499778 5.47849 0.235352 6.125 0.235352H7.875ZM2.625 3.36523C2.34338 3.36523 2.06927 3.48054 1.86426 3.69141C1.65891 3.90283 1.54009 4.1933 1.54004 4.5V15.2998C1.5401 15.6066 1.65873 15.8979 1.86426 16.1094C2.06926 16.3202 2.34344 16.4355 2.625 16.4355H11.375C11.6566 16.4355 11.9307 16.3202 12.1357 16.1094C12.3413 15.8979 12.4599 15.6066 12.46 15.2998V4.5C12.4599 4.1933 12.3411 3.90284 12.1357 3.69141C11.9307 3.48054 11.6566 3.36523 11.375 3.36523H10.1982C10.0883 3.76479 9.8818 4.13522 9.58887 4.43652C9.13753 4.90058 8.52149 5.16504 7.875 5.16504H6.125C5.47851 5.16504 4.86247 4.90058 4.41113 4.43652C4.1182 4.13522 3.91173 3.76479 3.80176 3.36523H2.625ZM4.51758 11.9492C4.82062 12.0112 5.04883 12.2792 5.04883 12.6006C5.04851 12.9217 4.82049 13.1901 4.51758 13.252L4.38379 13.2656H4.375C4.00796 13.2656 3.71033 12.9675 3.70996 12.6006C3.70996 12.2333 4.00773 11.9355 4.375 11.9355H4.38379L4.51758 11.9492ZM9.75879 11.9492C10.0619 12.0112 10.29 12.2792 10.29 12.6006C10.2897 12.9217 10.0617 13.1901 9.75879 13.252L9.625 13.2656H6.875C6.50796 13.2656 6.21033 12.9675 6.20996 12.6006C6.20996 12.2333 6.50773 11.9355 6.875 11.9355H9.625L9.75879 11.9492ZM4.51758 8.34863C4.82056 8.41056 5.04864 8.67876 5.04883 9C5.0486 9.32124 4.82059 9.59047 4.51758 9.65234L4.38379 9.66504H4.375C4.00789 9.66504 3.71022 9.36705 3.70996 9C3.71017 8.63291 4.00786 8.33496 4.375 8.33496H4.38379L4.51758 8.34863ZM9.75879 8.34863C10.0618 8.41055 10.2899 8.67875 10.29 9C10.2898 9.32126 10.0618 9.59049 9.75879 9.65234L9.625 9.66504H6.875C6.50789 9.66504 6.21022 9.36705 6.20996 9C6.21017 8.63291 6.50786 8.33496 6.875 8.33496H9.625L9.75879 8.34863ZM6.125 1.56543C5.84338 1.56543 5.56927 1.68073 5.36426 1.8916C5.15899 2.10302 5.04009 2.39356 5.04004 2.7002C5.04016 3.00699 5.15873 3.29837 5.36426 3.50977C5.56924 3.72047 5.8435 3.83496 6.125 3.83496H7.875C8.1565 3.83496 8.43076 3.72047 8.63574 3.50977C8.84127 3.29837 8.95984 3.00699 8.95996 2.7002C8.95991 2.39356 8.84101 2.10302 8.63574 1.8916C8.43073 1.68073 8.15662 1.56543 7.875 1.56543H6.125Z"
        fill="black"
      />
    </svg>
  );
};

export const CheckedClipboardIcon = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.06348 0.844727C8.59781 0.89767 9.1004 1.1336 9.4834 1.5166C9.75982 1.79302 9.95953 2.13192 10.0693 2.5H11.167L11.3975 2.51172C11.9315 2.56479 12.4345 2.80075 12.8174 3.18359C13.2546 3.62113 13.5 4.2154 13.5 4.83398V14.834C13.4998 15.4524 13.2546 16.046 12.8174 16.4834C12.3799 16.9209 11.7857 17.1669 11.167 17.167H2.83398C2.21532 17.167 1.62114 16.9208 1.18359 16.4834C0.800952 16.1007 0.564869 15.5983 0.511719 15.0645L0.5 14.834V4.83398C0.5 4.21517 0.746045 3.62117 1.18359 3.18359C1.62118 2.74601 2.21515 2.5 2.83398 2.5H3.93066C4.04047 2.13192 4.24018 1.79302 4.5166 1.5166C4.95419 1.07902 5.54815 0.833008 6.16699 0.833008H7.83301L8.06348 0.844727ZM2.83398 3.83398C2.56877 3.83398 2.31449 3.93942 2.12695 4.12695C1.93945 4.31448 1.83398 4.56879 1.83398 4.83398V14.834L1.83887 14.9326C1.86171 15.1613 1.963 15.3771 2.12695 15.541C2.31442 15.7281 2.5691 15.834 2.83398 15.834H11.167C11.432 15.8339 11.6866 15.7283 11.874 15.541C12.0614 15.3537 12.1668 15.0989 12.167 14.834V4.83398C12.167 4.56902 12.0612 4.31444 11.874 4.12695C11.71 3.9629 11.4945 3.86163 11.2656 3.83887L11.167 3.83398H10.0693C9.95948 4.20168 9.75963 4.54012 9.4834 4.81641C9.10041 5.1994 8.5978 5.43533 8.06348 5.48828L7.83301 5.5H6.16699C5.54815 5.5 4.95419 5.25399 4.5166 4.81641C4.24037 4.54012 4.04052 4.20168 3.93066 3.83398H2.83398ZM9.02832 8.52832C9.28867 8.26797 9.71133 8.26797 9.97168 8.52832C10.232 8.78867 10.232 9.21133 9.97168 9.47168L6.6377 12.8047C6.51276 12.9295 6.34361 12.9999 6.16699 13C5.99018 13 5.82034 12.9297 5.69531 12.8047L4.02832 11.1377L4.5 10.667L4.97168 10.1953L6.16602 11.3906L9.02832 8.52832ZM4.02832 10.1953C4.28867 9.93496 4.71133 9.93496 4.97168 10.1953L4.02832 11.1377C3.76835 10.8774 3.76824 10.4556 4.02832 10.1953ZM6.16699 2.16699C5.90178 2.16699 5.6475 2.27242 5.45996 2.45996C5.27242 2.6475 5.16699 2.90178 5.16699 3.16699C5.16708 3.43209 5.2725 3.68656 5.45996 3.87402C5.64747 4.06136 5.90193 4.16699 6.16699 4.16699H7.83301L7.93262 4.16211C8.16124 4.13931 8.37608 4.03783 8.54004 3.87402C8.7275 3.68656 8.83292 3.43209 8.83301 3.16699C8.83301 2.90178 8.72758 2.6475 8.54004 2.45996C8.37606 2.29598 8.16136 2.1947 7.93262 2.17188L7.83301 2.16699H6.16699Z"
        fill="black"
      />
    </svg>
  );
};

export const LargeEmailIcon = () => {
  return (
    <svg
      width="108"
      height="109"
      viewBox="0 0 108 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="54" cy="54.5" r="53.5" stroke="#AECDC2" />
      <circle cx="54" cy="54.5" r="48.5" stroke="#E4BDFF" />
      <path
        d="M33.4919 48.0034L51.5157 59.1866C53.2454 60.2632 55.4349 60.2632 57.1708 59.1866L75.1945 48.0034"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.5863 56.1323L37.9192 65.7793"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.094 56.1323L70.7611 65.7793"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.1138 47.4351L56.2091 36.0341C55.0478 35.3688 53.6265 35.3688 52.4652 36.0341L32.5665 47.4351"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.7412 70.2369H35.0644C33.6855 70.2369 32.5665 69.118 32.5665 67.739V47.4351M76.1138 47.4351V67.739C76.1138 69.118 74.9949 70.2369 73.6159 70.2369H67.7854"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MediumEmailIcon = () => {
  return (
    <svg
      width="74"
      height="73"
      viewBox="0 0 74 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="37" cy="36.4999" r="35.6698" stroke="#AECDC2" />
      <circle cx="37" cy="36.5004" r="32.3208" stroke="#E4BDFF" />
      <path
        d="M23.07 32.1494L35.3125 39.64C36.4875 40.3611 37.9747 40.3611 39.1537 39.64L51.3963 32.1494"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9643 37.5938L26.0772 44.0554"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.4978 37.5938L48.3849 44.0554"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.0207 31.7685L38.5005 24.1321C37.7117 23.6864 36.7463 23.6864 35.9575 24.1321L22.4414 31.7685"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.9374 47.0415H24.1381C23.2014 47.0415 22.4414 46.292 22.4414 45.3684V31.7686M52.0207 31.7686V45.3684C52.0207 46.292 51.2607 47.0415 50.324 47.0415H46.3637"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LargePhoneIcon = () => {
  return (
    <svg
      width="108"
      height="109"
      viewBox="0 0 108 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="54" cy="54.5" r="53.5" stroke="#AECDC2" />
      <circle cx="54" cy="54.5" r="48.5" stroke="#E4BDFF" />
      <path
        d="M63.7363 32.1001H44.2637C41.7297 32.1001 39.6755 34.1362 39.6755 36.6479V72.3523C39.6755 74.864 41.7297 76.9001 44.2637 76.9001H63.7363C66.2703 76.9001 68.3245 74.864 68.3245 72.3523V36.6479C68.3245 34.1362 66.2703 32.1001 63.7363 32.1001Z"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.8198 37.1997H43.1802V68.2484H64.8198V37.1997Z"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.0456 34.5718H53.888"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.7632 34.5718H57.2898"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.3698 72.8983C56.3698 74.1942 55.3105 75.2502 53.997 75.2502C52.6835 75.2502 51.6242 74.2002 51.6242 72.8983C51.6242 71.5963 52.6835 70.5464 53.997 70.5464C55.3105 70.5464 56.3698 71.5963 56.3698 72.8983Z"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MediumPhoneIcon = () => {
  return (
    <svg
      width="74"
      height="73"
      viewBox="0 0 74 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="37" cy="36.4999" r="35.6698" stroke="#AECDC2" />
      <circle cx="37" cy="36.5004" r="32.3208" stroke="#E4BDFF" />
      <path
        d="M43.6133 21.4961H30.3867C28.6655 21.4961 27.2701 22.8599 27.2701 24.5423V48.4575C27.2701 50.1399 28.6655 51.5037 30.3867 51.5037H43.6133C45.3346 51.5037 46.7299 50.1399 46.7299 48.4575V24.5423C46.7299 22.8599 45.3346 21.4961 43.6133 21.4961Z"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.3493 24.9121H29.6507V45.7088H44.3493V24.9121Z"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6348 23.1523H36.9239"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8769 23.1523H39.2346"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6097 48.8234C38.6097 49.6914 37.8901 50.3987 36.998 50.3987C36.1058 50.3987 35.3862 49.6954 35.3862 48.8234C35.3862 47.9513 36.1058 47.248 36.998 47.248C37.8901 47.248 38.6097 47.9513 38.6097 48.8234Z"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LargeFaxIcon = () => {
  return (
    <svg
      width="108"
      height="109"
      viewBox="0 0 108 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="54" cy="54.5" r="53.5" stroke="#AECDC2" />
      <circle cx="54" cy="54.5" r="48.5" stroke="#E4BDFF" />
      <path
        d="M44.8874 61.3867H63.1126"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8874 65.2227H63.1126"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8874 69.0581H63.1126"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1328 64.261H32.4214C31.8924 64.261 31.46 63.8379 31.46 63.3228V46.3418C31.46 45.822 31.8878 45.0815 32.4214 45.0815H75.5832C76.1122 45.0815 76.5446 45.822 76.5446 46.3418V63.3228C76.5446 63.8425 76.1168 64.261 75.5832 64.261H68.8672"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1328 57.9185V74.6189H68.8672V57.9185"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2578 49.8789H42.9692"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1328 60.4254H36.2578V57.5508H71.7422V60.4254H68.8672"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.8672 33.5742H39.1328V45.0819H68.8672V33.5742Z"
        stroke="#1D1311"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MediumFaxIcon = () => {
  return (
    <svg
      width="74"
      height="73"
      viewBox="0 0 74 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="37" cy="36.4999" r="35.6698" stroke="#AECDC2" />
      <circle cx="37" cy="36.5004" r="32.3208" stroke="#E4BDFF" />
      <path
        d="M30.8103 41.1133H43.1897"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8103 43.6826H43.1897"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8103 46.252H43.1897"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9015 43.038H22.3428C21.9835 43.038 21.6898 42.7546 21.6898 42.4096V31.0355C21.6898 30.6874 21.9804 30.1914 22.3428 30.1914H51.6603C52.0196 30.1914 52.3133 30.6874 52.3133 31.0355V42.4096C52.3133 42.7577 52.0227 43.038 51.6603 43.038H47.0985"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9015 38.79V49.9762H47.0985V38.79"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9487 33.4053H29.5074"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9015 40.4694H24.9487V38.5439H49.0513V40.4694H47.0985"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.0985 22.4844H26.9015V30.1924H47.0985V22.4844Z"
        stroke="#1D1311"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LargeInstaIcon = () => {
  return (
    <svg
      width="108"
      height="109"
      viewBox="0 0 108 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="54" cy="54.5" r="53.5" stroke="#AECDC2" />
      <circle cx="54" cy="54.5" r="48.5" stroke="#E4BDFF" />
      <g clipPath="url(#clip0_570_1040)">
        <path
          d="M43.1724 32.6958H64.8276C70.8898 32.6959 75.8041 37.6102 75.8042 43.6724V65.3276C75.8041 71.3898 70.8898 76.3041 64.8276 76.3042H43.1724C37.1102 76.3041 32.1959 71.3898 32.1958 65.3276V43.6724C32.1959 37.6102 37.1102 32.6959 43.1724 32.6958Z"
          stroke="#1D1311"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M54 65.7164C60.1948 65.7164 65.2166 60.6945 65.2166 54.4998C65.2166 48.305 60.1948 43.2832 54 43.2832C47.8053 43.2832 42.7834 48.305 42.7834 54.4998C42.7834 60.6945 47.8053 65.7164 54 65.7164Z"
          stroke="#1D1311"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M67.6373 43.3152C69.0042 43.3152 70.1122 42.2071 70.1122 40.8402C70.1122 39.4733 69.0042 38.3652 67.6373 38.3652C66.2704 38.3652 65.1623 39.4733 65.1623 40.8402C65.1623 42.2071 66.2704 43.3152 67.6373 43.3152Z"
          fill="#1D1311"
        />
      </g>
      <defs>
        <clipPath id="clip0_570_1040">
          <rect
            width="46"
            height="46"
            fill="white"
            transform="translate(31 31.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MediumInstaIcon = () => {
  return (
    <svg
      width="74"
      height="73"
      viewBox="0 0 74 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="37" cy="36.4999" r="35.6698" stroke="#AECDC2" />
      <circle cx="37" cy="36.5004" r="32.3208" stroke="#E4BDFF" />
      <g clipPath="url(#clip0_639_515)">
        <path
          d="M29.6451 21.7256H44.3541C48.5775 21.7256 51.9899 25.1003 51.9899 29.248V43.752C51.9899 47.8997 48.5775 51.2744 44.3541 51.2744H29.6451C25.4219 51.2742 22.0104 47.8996 22.0104 43.752V29.248L22.0201 28.8613C22.2242 24.8925 25.5539 21.7258 29.6451 21.7256Z"
          stroke="#1D1311"
          strokeMiterlimit="10"
        />
        <path
          d="M37 44.0133C41.2078 44.0133 44.6188 40.6496 44.6188 36.5003C44.6188 32.351 41.2078 28.9873 37 28.9873C32.7923 28.9873 29.3812 32.351 29.3812 36.5003C29.3812 40.6496 32.7923 44.0133 37 44.0133Z"
          stroke="#1D1311"
          strokeMiterlimit="10"
        />
        <path
          d="M46.2631 29.0089C47.1915 29.0089 47.9442 28.2667 47.9442 27.3511C47.9442 26.4356 47.1915 25.6934 46.2631 25.6934C45.3346 25.6934 44.5819 26.4356 44.5819 27.3511C44.5819 28.2667 45.3346 29.0089 46.2631 29.0089Z"
          fill="#1D1311"
        />
      </g>
      <defs>
        <clipPath id="clip0_639_515">
          <rect
            width="31.2453"
            height="30.8113"
            fill="white"
            transform="translate(21.3774 21.0947)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LargeCouchIcon = () => {
  return (
    <svg
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="43" cy="43" r="42.2924" stroke="#AECDC2" />
      <circle cx="43" cy="43.0001" r="38.3302" stroke="#E4BDFF" />
      <path
        d="M58.6915 51.1769H27.3085C26.0683 51.1769 25.0652 50.1651 25.0652 48.9141V37.357C25.0652 36.106 26.0683 35.0942 27.3085 35.0942C28.5487 35.0942 29.5518 36.106 29.5518 37.357V46.6553H56.456V37.357C56.456 36.106 57.4591 35.0942 58.6993 35.0942C59.9395 35.0942 60.9426 36.106 60.9426 37.357V48.9141C60.9426 50.1651 59.9395 51.1769 58.6993 51.1769H58.6915Z"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.3085 35.0942C27.3085 32.7373 29.2019 30.8235 31.5424 30.8235H54.582C56.9225 30.8235 58.8159 32.7373 58.8159 35.0942"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8036 42.1294H55.1962C55.8883 42.1294 56.452 42.698 56.452 43.3961V46.6511H29.5479V43.3961C29.5479 42.698 30.1116 42.1294 30.8036 42.1294Z"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0621 30.8235V46.6513"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2796 51.177L28.0199 55.8163H29.2796L31.6123 51.177"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.8447 51.177L58.1044 55.8163H56.8447L54.5159 51.177"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LargeOfficeIcon = () => {
  return (
    <svg
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="43" cy="43" r="42.2924" stroke="#AECDC2" />
      <circle cx="43" cy="43.0001" r="38.3302" stroke="#E4BDFF" />
      <g clipPath="url(#clip0_694_638)">
        <path
          d="M25.4131 57.7434H60.9481"
          stroke="#1D1311"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M58.7637 57.7433V35.2586H48.5118V28.6108L27.5713 35.2586V57.7433"
          stroke="#1D1311"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.7494 39.3015H30.1635V44.2602H36.7494V39.3015Z"
          stroke="#1D1311"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.7494 46.988H30.1635V51.9468H36.7494V46.988Z"
          stroke="#1D1311"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.5662 39.3015H49.9802V44.2602H56.5662V39.3015Z"
          stroke="#1D1311"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.5662 46.988H49.9802V51.9468H56.5662V46.988Z"
          stroke="#1D1311"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.158 57.7434V46.988H47.2163V57.7434"
          stroke="#1D1311"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_694_638">
          <rect
            width="36.4528"
            height="36.4528"
            fill="white"
            transform="translate(24.7736 24.7737)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LargeVirtualMeetingIcon = () => {
  return (
    <svg
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="43" cy="43" r="42.2924" stroke="#AECDC2" />
      <circle cx="43" cy="43.0001" r="38.3302" stroke="#E4BDFF" />
      <path
        d="M51.0401 25.1616H34.96C33.4311 25.1616 32.1918 26.4153 32.1918 27.9618V58.0386C32.1918 59.5851 33.4311 60.8388 34.96 60.8388H51.0401C52.5689 60.8388 53.8083 59.5851 53.8083 58.0386V27.9618C53.8083 26.4153 52.5689 25.1616 51.0401 25.1616Z"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1918 56.2271H53.8083"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.619 58.5776H45.3771"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.9999 38.4527C40.5269 38.4527 38.5217 36.4243 38.5217 33.9228C38.5217 31.4212 40.5269 29.3928 42.9999 29.3928C45.4729 29.3928 47.4781 31.4212 47.4781 33.9228C47.4781 36.4243 45.4729 38.4527 42.9999 38.4527Z"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1332 48.1719V46.0931C36.1332 42.2574 39.2081 39.147 43 39.147C46.7919 39.147 49.8668 42.2574 49.8668 46.0931V48.1719"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.549 49.8203H39.8484V53.4156H44.549V49.8203Z"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.549 52.5001L47.1293 53.0664V51.6197V50.1731L44.549 50.7355"
        stroke="#1D1311"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MediumClipboardIcon = () => {
  return (
    <svg
      width="27"
      height="34"
      viewBox="0 0 27 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4053 0.706055C16.4885 0.760309 17.5156 1.21697 18.2842 1.99121C18.8647 2.57612 19.2627 3.30842 19.4463 4.09961H21.9375L22.1553 4.10547C23.2384 4.15972 24.2656 4.61647 25.0342 5.39062C25.8537 6.21626 26.3124 7.33556 26.3125 8.5V28.8994C26.3125 30.0637 25.8534 31.1822 25.0342 32.0078C24.2143 32.8338 23.1002 33.2998 21.9375 33.2998H5.0625C3.89979 33.2998 2.78571 32.8338 1.96582 32.0078C1.14656 31.1822 0.6875 30.0637 0.6875 28.8994V8.5C0.687578 7.33556 1.14629 6.21627 1.96582 5.39062C2.7857 4.56475 3.89986 4.09961 5.0625 4.09961H7.55371C7.73731 3.30842 8.13531 2.57612 8.71582 1.99121C9.53571 1.16524 10.6498 0.700195 11.8125 0.700195H15.1875L15.4053 0.706055ZM5.0625 6.09961C4.43511 6.09961 3.8317 6.35067 3.38574 6.7998C2.93959 7.24926 2.68758 7.86122 2.6875 8.5V28.8994C2.6875 29.5382 2.93961 30.1501 3.38574 30.5996C3.8317 31.0488 4.43508 31.2998 5.0625 31.2998H21.9375C22.5649 31.2998 23.1683 31.0488 23.6143 30.5996C24.0604 30.1501 24.3125 29.5382 24.3125 28.8994V8.5C24.3124 7.86122 24.0604 7.24926 23.6143 6.7998C23.2242 6.40693 22.7135 6.1656 22.1719 6.11133L21.9375 6.09961H19.4463C19.2627 6.89095 18.8649 7.62389 18.2842 8.20898C17.5156 8.98312 16.4884 9.44088 15.4053 9.49512L15.1875 9.5H11.8125C10.6499 9.5 9.5357 9.03483 8.71582 8.20898C8.1351 7.62389 7.73728 6.89095 7.55371 6.09961H5.0625ZM8.55664 22.8057C9.06073 22.8569 9.4539 23.2822 9.4541 23.7998C9.45391 24.3174 9.06076 24.7437 8.55664 24.7949L8.4541 24.7998H8.4375C7.88534 24.7998 7.43771 24.3519 7.4375 23.7998C7.43771 23.2477 7.88535 22.7998 8.4375 22.7998H8.4541L8.55664 22.8057ZM18.665 22.8057C19.169 22.857 19.5623 23.2823 19.5625 23.7998C19.5623 24.3173 19.169 24.7436 18.665 24.7949L18.5625 24.7998H13.2588C12.7067 24.7997 12.259 24.3519 12.2588 23.7998C12.259 23.2477 12.7067 22.7999 13.2588 22.7998H18.5625L18.665 22.8057ZM8.55664 16.0049C9.06083 16.0561 9.454 16.4823 9.4541 17C9.45391 17.5176 9.06077 17.9439 8.55664 17.9951L8.4541 18H8.4375C7.88534 18 7.43771 17.5521 7.4375 17C7.43761 16.4478 7.88528 16 8.4375 16H8.4541L8.55664 16.0049ZM18.665 16.0049C19.1691 16.0562 19.5624 16.4824 19.5625 17C19.5623 17.5175 19.169 17.9438 18.665 17.9951L18.5625 18H13.2588C12.7067 17.9999 12.259 17.5521 12.2588 17C12.2589 16.4479 12.7066 16.0001 13.2588 16H18.5625L18.665 16.0049ZM11.8125 2.7002C11.185 2.7002 10.5817 2.95116 10.1357 3.40039C9.68964 3.8499 9.4375 4.46179 9.4375 5.10059C9.4377 5.73919 9.68971 6.35046 10.1357 6.7998C10.5817 7.24896 11.1851 7.5 11.8125 7.5H15.1875L15.4219 7.48828C15.9636 7.434 16.4742 7.1927 16.8643 6.7998C17.3103 6.35046 17.5623 5.73919 17.5625 5.10059C17.5625 4.46179 17.3104 3.8499 16.8643 3.40039C16.4742 3.00743 15.9636 2.7662 15.4219 2.71191L15.1875 2.7002H11.8125Z"
        fill="black"
      />
    </svg>
  );
};

export const MediumCheckedClipboardIcon = () => {
  return (
    <svg
      width="27"
      height="34"
      viewBox="0 0 27 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3154 1.83789C16.3511 1.88831 17.3378 2.3141 18.0801 3.04102C18.6287 3.5785 19.012 4.25127 19.1963 4.98145H21.5361L21.7432 4.98633C22.7792 5.03656 23.7654 5.46232 24.5078 6.18945C25.3003 6.9657 25.75 8.02297 25.75 9.12988V28.0186C25.7499 29.1254 25.3003 30.1828 24.5078 30.959C23.7161 31.7342 22.6469 32.1669 21.5361 32.167H5.46387C4.3531 32.1669 3.28391 31.7343 2.49219 30.959C1.74924 30.2313 1.30721 29.2566 1.25488 28.2256L1.25 28.0186V9.12988C1.25 8.02298 1.69968 6.9657 2.49219 6.18945C3.28393 5.41403 4.35299 4.98156 5.46387 4.98145H7.80273C7.98723 4.25117 8.37203 3.57859 8.9209 3.04102C9.71262 2.26573 10.7818 1.83312 11.8926 1.83301H15.1074L15.3154 1.83789ZM5.46387 6.98145C4.87019 6.98156 4.30523 7.21311 3.8916 7.61816C3.47863 8.02269 3.25 8.56699 3.25 9.12988V28.0186L3.26074 28.2285C3.3101 28.7153 3.53025 29.1764 3.8916 29.5303C4.30521 29.9352 4.8703 30.1669 5.46387 30.167H21.5361C22.1297 30.1669 22.6948 29.9352 23.1084 29.5303C23.5214 29.1258 23.7499 28.5814 23.75 28.0186V9.12988C23.75 8.56698 23.5214 8.02269 23.1084 7.61816C22.7464 7.26365 22.2685 7.04199 21.7568 6.99219L21.5361 6.98145H19.1963C19.0121 7.71177 18.6289 8.3843 18.0801 8.92188C17.3378 9.64884 16.3511 10.0736 15.3154 10.124L15.1074 10.1289H11.8926C10.7818 10.1288 9.71262 9.69712 8.9209 8.92188C8.37198 8.38422 7.98718 7.71192 7.80273 6.98145H5.46387ZM18.3213 17L19.0215 17.7139L12.5928 24.0107C12.2041 24.3913 11.5821 24.3913 11.1934 24.0107L7.97852 20.8623L7.90918 20.7871C7.58506 20.3978 7.60192 19.8181 7.96387 19.4482C8.3261 19.0786 8.90577 19.0492 9.30176 19.3652L9.37891 19.4336L11.8926 21.8965L17.6221 16.2852L18.3213 17ZM17.6221 16.2852C18.0166 15.8991 18.6498 15.9055 19.0361 16.2998C19.4224 16.6942 19.4156 17.3274 19.0215 17.7139L17.6221 16.2852ZM11.8926 3.83301C11.299 3.83312 10.7339 4.06481 10.3203 4.46973C9.90736 4.87418 9.6788 5.41862 9.67871 5.98145C9.67879 6.54424 9.90741 7.08871 10.3203 7.49316C10.7339 7.89805 11.299 8.1288 11.8926 8.12891H15.1074L15.3281 8.11816C15.8399 8.06838 16.3186 7.84773 16.6807 7.49316C17.0935 7.08872 17.3212 6.54417 17.3213 5.98145C17.3212 5.41874 17.0935 4.87416 16.6807 4.46973C16.3186 4.11516 15.8399 3.89352 15.3281 3.84375L15.1074 3.83301H11.8926Z"
        fill="black"
      />
    </svg>
  );
};
